/**
 * #faq accordion. Each item is a <h3><button aria-expanded aria-controls> +
 * region pattern (WAI-ARIA accordion). Buttons are native, so Enter/Space and
 * Tab order work without custom key handling; the 48px minimum height keeps
 * the whole row tappable on phones. Chevron rotation respects reduced motion
 * via the global motion-safe rule in index.css.
 */
import { useId, useState } from "react";
import { Icon } from "./icons";
import { FAQ_ITEMS } from "./content";
import { Section } from "./Sections";

export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const baseId = useId();

  return (
    <Section
      id="faq"
      eyebrow="FAQ"
      title="Questions, answered plainly"
      intro="What StampmatS proves, what it does not, and how your data is handled."
      tone="soft"
    >
      <div className="max-w-3xl divide-y divide-border rounded-xl border border-border bg-white">
        {FAQ_ITEMS.map((item, i) => {
          const open = openIndex === i;
          const buttonId = `${baseId}-q-${i}`;
          const panelId = `${baseId}-a-${i}`;
          return (
            <div key={item.question}>
              <h3 className="font-sans text-base tracking-normal">
                <button
                  type="button"
                  id={buttonId}
                  aria-expanded={open}
                  aria-controls={panelId}
                  onClick={() => setOpenIndex(open ? null : i)}
                  className="flex min-h-[56px] w-full items-center justify-between gap-4 px-4 py-3 text-left font-medium text-ink transition-colors hover:text-aigentico-navy sm:px-6"
                >
                  <span>{item.question}</span>
                  <Icon
                    name="chevron"
                    size={20}
                    className={`shrink-0 text-aigentico-navy transition-transform duration-200 motion-reduce:transition-none ${
                      open ? "rotate-180" : ""
                    }`}
                  />
                </button>
              </h3>
              <div
                id={panelId}
                role="region"
                aria-labelledby={buttonId}
                hidden={!open}
                className="px-4 pb-5 sm:px-6"
              >
                <p className="text-sm leading-relaxed text-ink-soft sm:text-base">{item.answer}</p>
              </div>
            </div>
          );
        })}
      </div>
    </Section>
  );
}
